import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id EEECC393-B78C-43DE-BDA4-F31DACA25F56
 * name download-multiple
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/download-multiple.svg
 * tags
 */
export const DownloadMultipleIcon = createSvgIcon(<><path d="M9,1V7H5L12,14L19,7H15V1H9M5,16V18H19V16H5M5,20V22H19V20H5Z" /></>, 'DownloadMultipleIcon');
export default DownloadMultipleIcon